import React from "react"

import SEO from "~components/shared/SEO"
import { CompetitorCopy } from "./resources/_copy-template"

export const ComparisonSeo: React.FC<{ copy: CompetitorCopy }> = ({ copy }) => (
    <SEO
        title={`Chckvet vs ${copy.company}`}
        description={`${copy.company} vs Chckvet: ${copy.landing.subtitle}`}
    />
)
